import axios from 'axios';
import type { PageListItemModel } from '#layers/cms/app/pages/cms/management/pages/_runtime/services/PagesService';
import BasePagesService from '#layers/cms/app/pages/cms/management/pages/_runtime/services/PagesService';

export default class PagesService extends BasePagesService
{
    public static async getPagesWithoutElementsByFolder(folderId: number): Promise<PageListItemModel[]>
    {
        return (await axios.get<PageListItemModel[]>('admin/cms/pages/options-without-elements', {
            params: {
                folder: folderId
            }
        })).data;
    }
}
